module.exports = __webpack_public_path__ + "assets/img/653000.137e9fc1.png";